import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./Slice/authSlice";
import messageSlice from "./Slice/messageSlice";
import alertStatus from "./Slice/alertStatusSlice";
import usersSlice from "./Slice/usersSlice";
import userGroupSlice from "./Slice/userGroupSlice";
import departmentDetailSlice from "./Slice/departmentDetailSlice";
import labFormSlice from "./Slice/labFormSlice";
import labSlice from "./Slice/labSlice";
import settingSlice from "./Slice/settingSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    message: messageSlice,
    alert: alertStatus,
    users: usersSlice,
    userGroup: userGroupSlice,
    departmentDetail: departmentDetailSlice,
    labForm: labFormSlice,
    lab: labSlice,
    setting: settingSlice,
  },
});
